<template>
    <div :name="`name${data.qid}`"  class="test_question list">
        <p
            :class="{ 'title': data.quesIndex >= 0}"
            :style="{
                fontSize: bandingstyle.appearancePhone.fontStemSize+'px',
                color:bandingstyle.appearancePhone.fontStemColor,
                fontWeight: bandingstyle.appearancePhone.fontStemBold,
                fontStyle: bandingstyle.appearancePhone.fontStemItalic,
                textDecoration: bandingstyle.appearancePhone.fontStemUnderline
            }"
        >
            <span v-if="data.mustanswer" class="required"></span>
            <HtmlClickImgEnlarge :content="data.questionsName"/></p>

        <div class="input_box"
            :style="{display: data.questionsTypeId == '11' || 
            data.questionsTypeId == '15' || 
            data.questionsTypeId == '33'||
            data.questionsTypeId == '38'||
            data.questionsTypeId == '13'
            ? 'block': 'flex'}"
        >
            
            <!-- 排序 -->
            <div class="sort-box" v-if="data.questionsTypeId == '14'">
                <ul ref="geoChilds"  class="ulChildName before-sort">
                    <template v-for="(item) in data.sortArray">
                    <li 
                        :style="{
                            fontSize: bandingstyle.appearancePhone.fontOptionSize+'px !important',
                            color:bandingstyle.appearancePhone.fontOptionColor,
                            fontWeight: bandingstyle.appearancePhone.fontOptionBold,
                            fontStyle: bandingstyle.appearancePhone.fontOptionItalic,
                            textDecoration: bandingstyle.appearancePhone.fontOptionUnderline,
                        }"
                        :key="item.oid"
                        :entityid="item.oid" 
                        class="info-body-item"
                        @click="setSortIndex(item,item.optionIndex)"
                    >
                        <span 
                            class="option-sort"
                            :style="{
                                borderColor: item.optionIndex ? '#409EFF' : '#DCDFE6',
                                background: item.optionIndex ? '#409EFF' : '#fff',
                                color: item.optionIndex ? '#fff' : '#666'
                            }"
                        >{{item.optionIndex ? item.optionIndex : ''}}</span>
                        <HtmlClickImgEnlarge :content="item.labelName"/>
                    </li>
					<div 
						:key="`op${item.oid}`"
						v-if="item.haveInput && data.userAnswerArr.indexOf(item.oid) !== -1"
						class="other-input">
						<el-input
							@input="inputValueChange(item)"
							size="medium"
							:placeholder="$t('UserAnswer.PleaseEnter')"
							v-model="item.inputValue"
							>
						</el-input>
					</div>
					</template>
                </ul>
            </div>
            
            <!-- 星级评分 -->
            <template v-else-if="data.questionsTypeId == '11'">
                <ul class="StarsWrap">
                    <li class="StarsWrap-item" v-for="(i,index) in  (data.highestScore - data.lowestScore + 1)" :key="index"
                        @click="clickStars(index)">
                        <img 
                            :src="parseInt(data.userAnswer) >= index + data.lowestScore? scoreImgUrlYes:scoreImgUrlNo"
                            alt="" />
                    </li>
                </ul>
                <div class="tips">
                    <span
                        v-if="data.leftPromptText!=''">{{ data.leftPromptText }}</span>
                    <span
                        v-if="data.centerPromptText!=''">{{data.centerPromptText}}</span>
                    <span
                        v-if="data.rightPromptText!=''">{{data.rightPromptText}}</span>
                </div>
            </template>
            <!-- 日期选择 -->
            <div v-else-if="data.questionsTypeId == '13'">
                <el-date-picker 
					:append-to-body="false" 
					@change="userAnswerChange" 
                    :format="`yyyy ${$t('UserAnswer.Year')} MM ${$t('UserAnswer.Month')} dd ${$t('UserAnswer.Day')}`"
                    :value-format="`yyyy ${$t('UserAnswer.Year')} MM ${$t('UserAnswer.Month')} dd ${$t('UserAnswer.Day')}`"
					v-model="data.userAnswer" 
					type="date" :placeholder="$t('UserAnswer.SelectDate')"
      				:picker-options="pickerOptions"
					>
				</el-date-picker>
            </div>
            <!-- 位置选择 -->
            <template v-else-if="data.questionsTypeId == '15'">
                <button class="baiduMap-btn" @click="getLocation(data.qid)">
                    <i class="el-icon-location-outline"></i>
                    <span>{{$t('UserAnswer.GetLocation')}}</span>
                </button>
                <div v-if="mapIsShow" class="map-box">
                    
                    <div class="tip">
                        <div>
                            <span class="your-location">{{$t('UserAnswer.YourLocation')}}: {{weizhi[data.qid]}}</span>
                            <input :id="`lnglat-${data.qid}`" type="text"
                                style="display: none;" value="116.39,39.9" />
                            <input :id="`address-${data.qid}`" type="text"
                                style="display: none;" disabled />
                        </div>
                        <div class="search-box">
                            <el-input
                                size="small"
                                :placeholder="$t('UserAnswer.SearchAddress')"
                                v-model="mapSearchValue"
                                :id="'search-'+data.qid">
                                <i slot="prefix" class="el-input__icon el-icon-location-outline"></i>
                            </el-input>
                            <el-button size="small" type="primary" plain class="clear-btn" @click="cityHide(data.qid)">
                                {{ $t('UserAnswer.Clear') }}
                            </el-button>
                        </div>
                    </div>
                    <div class="getCity" :id="`map-${data.qid}`" style="width:100%;height:500px;margin-top:10px"></div>
                    
                </div>
            </template>
            <!-- 城市选择 -->
            <template v-else-if="data.questionsTypeId == '16'">
                <div class="citySelect">
                    <!-- 省 -->
                    <el-select class="Select"
                        :popper-append-to-body="false"
                        v-if="data.choiceRange >= 1"
                        v-model="answerArr[0]"
                        :value-key="`${data.qid}-3`"
                        :placeholder="$t('UserAnswer.SelectAProvince')"
                        @change="seleCity($event,0)">
                        <el-option class="SelectOption" v-for="item in address.province"
                            :key="item.id" :label="item.name" :value="item.id">
                        </el-option>
                    </el-select>
                    <!-- 市 -->
                    <el-select class="Select"
                        :popper-append-to-body="false"
                        v-if="data.choiceRange >= 2"
                        v-model="answerArr[1]"
                        :value-key="`${data.qid}-2`"
                        :placeholder="$t('UserAnswer.SelectACity')"
                        @change="seleCity($event,1)">
                        <el-option class="SelectOption"
                            v-for="item in address.city"
                            :key="item.id" :label="item.name" :value="item.id">
                        </el-option>
                    </el-select>
                    <!-- 区 / 县 -->
                    <el-select class="Select"
                        :popper-append-to-body="false"
                        v-if="data.choiceRange >= 3"
                        v-model="answerArr[2]"
                        :value-key="`${data.qid}-1`"
                        :placeholder="$t('UserAnswer.SelectADistrict')"
                        @change="seleCity($event,2)">
                        <el-option class="SelectOption"
                            v-for="item in address.district"
                            :key="item.id" :label="item.name" :value="item.id">
                        </el-option>
                    </el-select>
                    <!-- 详细地址 -->
                    <el-input v-if="data.choiceRange == 4"
                        type="textarea" resize="none" v-model="answerArr[3]"
                        :placeholder="$t('UserAnswer.DetailedAddress')" class="setStyle"
                        @blur="answerArrBlur">
                    </el-input>
                </div>
            </template>
            <!-- 时间选择 -->
            <template v-else-if="data.questionsTypeId == '17'">
                <el-time-picker
                    :append-to-body="false"
                    @change="userAnswerChange"
                    format="HH:mm"
                    value-format="HH:mm"
                    v-model="data.userAnswer"
                    :placeholder="$t('UserAnswer.Timing')">
                </el-time-picker>
            </template>
            <!-- 文件上传 -->
            <template v-else-if="data.questionsTypeId == '33'">
                <el-upload 
                    class="upload-demo" 
                    ref="upload" 
					:action="$config.service.uploadApi"
                    :data="qn"
                    :auto-upload="true" 
                    :limit="parseInt(data.maxFilesNum)"
                    :before-upload="beforeFileUpload"
                    :on-remove="( file, fileList) => handleRemove( file, fileList)"
                    :on-success="(response, file, fileList) => handleSuccess(response, file, fileList)"
                    :on-error="(err, file, fileList) =>handleerror(err, file, fileList)"
                    :on-exceed="(files, fileList)=>handleexceed(files, fileList)"
                    :file-list="data.fileList"
                    :multiple="true">
                    <el-button
                        style="height:43px;background:#fff;color:#333;width:100%"
                        type="primary"><img src="@/assets/uploadfile.png"
                            style="margin-right:10px" :alt="$t('UserAnswer.UploadFileImages')" />
                            {{ $t('UserAnswer.UploadFilesWithin10M') }}
                    </el-button>
                </el-upload>
            </template>
            <!-- 图片选择 -->
             <template v-else-if="data.questionsTypeId == '6'" >
                <div 
                    class="questionImage_box" 
                    v-for="(childItem,childindex) in data.optionList"
                    :key="childItem.oid+'_'+childindex"
                >
                    <el-image 
                        class="option-img"
                        :src="childItem.optionImgUrl" 
                        :preview-src-list="[childItem.optionImgUrl]">
                    </el-image>
                    <el-radio 
                        @change="userAnswerChange"
                        class="imgLabel"
                        v-model="data.userAnswer" :label="childItem.oid"
                        v-if="data.cutType == 7"
                        :style="{
                            fontSize: bandingstyle.appearancePhone.fontOptionSize+'px !important',
                            color:bandingstyle.appearancePhone.fontOptionColor,
                            fontWeight: bandingstyle.appearancePhone.fontOptionBold,
                            fontStyle: bandingstyle.appearancePhone.fontOptionItalic,
                            textDecoration: bandingstyle.appearancePhone.fontOptionUnderline,
                        }"
                    >
                        <HtmlClickImgEnlarge :content="childItem.labelName"/>
                    </el-radio>
                    <el-checkbox 
                        @change="userAnswerChange"
                        class="imgLabel"
                        v-model="data.userAnswerArr"
                        :label="childItem.oid"
                        v-if="data.cutType == 8"
                        :style="{
                            fontSize: bandingstyle.appearancePhone.fontOptionSize+'px !important',
                            color:bandingstyle.appearancePhone.fontOptionColor,
                            fontWeight: bandingstyle.appearancePhone.fontOptionBold,
                            fontStyle: bandingstyle.appearancePhone.fontOptionItalic,
                            textDecoration: bandingstyle.appearancePhone.fontOptionUnderline,
                        }"
                    >
                        <HtmlClickImgEnlarge :content="childItem.labelName"/>
                    </el-checkbox>
                </div>
            </template>
            <!-- 量表题 -->
            <QuesScaleTM
                v-else-if="data.questionsTypeId == '38'"
                :data="data"
                @userAnswerChange="userAnswerChange"
            ></QuesScaleTM>
            <div v-show="data.validate" class="form-item__error">{{data.validateMsg}}</div>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex"
import QuesScaleTM from "./questionTypeTM/quesScale.vue"
import HtmlClickImgEnlarge from '@/components/myComponents/htmlClickImgEnlarge.vue'
export default {
    name:'OtherQuestionsPC',
    components: {
        QuesScaleTM,
        HtmlClickImgEnlarge
    },
    props: {
        data: {},
        bandingstyle:{},
    },
    data() {
        return {
            checkList: [],
            questionOption: [],
            weizhi: {},
            mapIsShow: false,
            mapSearchValue: '',
            address:{
                province: [],
                city: [],
                district: []
            },
            scoreImgUrlNo: require('@/assets/default-imgs/stars_2.png'),
            scoreImgUrlYes: require('@/assets/default-imgs/stars_1.png'),
            answerArr: [undefined, undefined, undefined, undefined],
            fileList: [],
            qn: {
                biz: 'upDataWj',
                data: {}
            },
            sortBoxHeight: '',
            draggableOptions: {
                handle: '.handle'
            },
            stars_2: require('@/assets/default-imgs/stars_2.png'),
            stars_1: require('@/assets/default-imgs/stars_1.png'),
            heart_2: require('@/assets/default-imgs/heart_2.png'),
            heart_1: require('@/assets/default-imgs/heart_1.png'),
            laugh_2: require('@/assets/default-imgs/laugh_2.png'),
            laugh_1: require('@/assets/default-imgs/laugh_1.png'),
            good_2: require('@/assets/default-imgs/good_2.png'),
            good_1: require('@/assets/default-imgs/good_1.png'),
            pickerOptions: {
                disabledDate: (time) => {
                    // 转换为当天0点
                    const normalizeDate = (date) => {
                        const d = new Date(date);
                        d.setHours(0, 0, 0, 0);
                        return d;
                    };

                    // 获取当前日期(0点)
                    const today = normalizeDate(new Date());
                    const timeDate = normalizeDate(time);
                    
                    // 1. 处理起始日期限制
                    let minDate = null;
                    if (this.data.startDateType === 1) { // 当日
                        minDate = today;
                    } else if (this.data.startDateType === 2 && this.data.startDate) { // 指定日期
                        minDate = normalizeDate(new Date(this.data.startDate));
                    }

                    // 2. 处理截止日期限制
                    let maxDate = null;
                    if (this.data.deadlineType === 1 && minDate) { // 起始日期后
                        // 这里假设"起始日期后"是指从起始日期开始可选
                        // 如果需要从起始日期+1天开始可选，改为 minDate.getTime() + 86400000
                        maxDate = null; // 不限制结束时间
                    } else if (this.data.deadlineType === 2 && this.data.deadline) { // 指定日期
                        maxDate = normalizeDate(new Date(this.data.deadline));
                    }

                    // 3. 组合判断
                    const isBeforeMin = minDate && timeDate.getTime() < minDate.getTime();
                    const isAfterMax = maxDate && timeDate.getTime() > maxDate.getTime();
                    
                    return isBeforeMin || isAfterMax;
                }
            }
        }
    },
	computed: {
	},
    watch:{
        'data':{
            handler(newV) {
                
                if (newV.questionsTypeId == '35') {
                    let result = false
                    if (newV.optionList.length > 0) {
                        newV.optionList.forEach((info) => {
                            if (info.userAnswer) {
                                result = true
                            }
                            // console.log(info.userAnswer)
                        })
                    }
                    if (result) {
                        newV.userAnswer = 1
                    } else {
                        newV.userAnswer = 0
                    }
                }
            },
            deep: true
        },
    },
    created() {
        if (this.data.questionsTypeId == '16') {
            this.getProvince()
        } else if (this.data.questionsTypeId == '11') {
            // this.data.userAnswer = 0
            if (this.data.scoreImg == 'star') {
                this.scoreImgUrlNo = this.stars_2
                this.scoreImgUrlYes = this.stars_1
            } else if (this.data.scoreImg == 'heart') {
                this.scoreImgUrlNo = this.heart_2
                this.scoreImgUrlYes = this.heart_1
                
            } else if (this.data.scoreImg == 'smile') {
                this.scoreImgUrlNo = this.laugh_2
                this.scoreImgUrlYes = this.laugh_1
                
            } else if (this.data.scoreImg == 'thumb') {
                this.scoreImgUrlNo = this.good_2
                this.scoreImgUrlYes = this.good_1
                
            }
        } else if (this.data.questionsTypeId == '14') {
            let sortArray = JSON.parse(JSON.stringify(this.data.optionList))
            if (!this.data.sortArray) {
                this.$set(this.data, 'sortArray', sortArray)
                this.data.sortArray.forEach((info) =>{
                    this.$set(info, 'optionIndex', 0)
                    this.data.userAnswerArr.forEach((item, index)=>{
                        if (item == info.oid) {
                            info.optionIndex = index + 1
                        }
                    })
                })
            }
        } else if(this.data.questionsTypeId == '15') {
            // console.log(this.data)
            if (this.data.userAnswer) {
                this.mapIsShow = true
                let str = this.data.userAnswer.split(':')
                this.$set(this.weizhi, this.data.qid, str[1]);
                this.getLocation(this.data.qid)
            }
        } else if(this.data.questionsTypeId == '33') {
            if (this.data.userAnswerArr.length == 0 && this.data.resultAnswerArrval) {
                this.data.resultAnswerArrval.forEach(info => {
                    let x = info.split('upDataWj/')[1]
                    this.data.fileList.push({name: x})
                    console.log(this.data.fileList)
                    this.data.userAnswerArr.push(info)
                })
            }
        }
    },
    methods: {
        inputValueChange(item) {
            this.data.optionList.forEach((info) => {
                if (info.oid == item.oid) {
                    info.inputValue = item.inputValue
                }
            })
            this.userAnswerChange()
        },
        setSortIndex(item, index) {
            // console.log(item)
            console.log(`index:${index}`)
            let maxIndex = 0
            if (index == 0) {
                this.data.sortArray.forEach((info) => {
                    if ( maxIndex < info.optionIndex) {
                        maxIndex = info.optionIndex
                    }
                })
                console.log(`this.data.sortsnums: ${this.data.sortsnums}`)
                if (this.data.sortsnums > 0 && maxIndex < this.data.sortsnums || (this.data.sortsnums == 0)) {
                    maxIndex++
                    item.optionIndex = maxIndex
                    console.log(item.optionIndex)
                }
            } else {
                this.data.sortArray.forEach((info) => {
                    if (info.optionIndex > item.optionIndex) {
                        info.optionIndex--
                    }
                })
                item.optionIndex = 0
            }
            console.log(this.data.sortArray)
            for(var i = 0; i < this.data.sortArray.length - 1; i++){
                for(var j = 0; j < this.data.sortArray.length - i - 1; j++) {
                    
                    if (this.data.sortArray[j].optionIndex > this.data.sortArray[j+1].optionIndex) {
                        var temp = this.data.sortArray[j]
                        this.data.sortArray[j] = this.data.sortArray[j+1]
                        this.data.sortArray[j+1] = temp
                    } 
                    if (this.data.sortArray[j].optionIndex == 0 && this.data.sortArray[j + 1].optionIndex != 0) {
                        var temp = this.data.sortArray[j]
                        this.data.sortArray[j] = this.data.sortArray[j+1]
                        this.data.sortArray[j+1] = temp
                    } 
                }
            }         
            this.data.userAnswerArr = []
            this.data.sortArray.forEach((info) => {
                // console.log(info.optionIndex)
                if(info.optionIndex != 0) {
                    this.data.userAnswerArr.push(info.oid)
                }
            })
            // console.log(this.data.userAnswerArr)
            this.userAnswerChange()
        },
        userAnswerChange(){
            this.$emit('userAnswerChange', this.data)
        },
        clickStars(i) {

            this.data.userAnswer =  i + this.data.lowestScore
            this.userAnswerChange()
        },
        getLocation(id) {
            this.mapIsShow = true
            let temp = !this.data.manualCorrectionPosition
            var that = this;
            var lat, lng;
            // var option = {};
            // option.id = id;
            AMapUI.loadUI(["misc/PositionPicker", "misc/PoiPicker"], function(
                PositionPicker,
                PoiPicker
            ) {
                var mapObj = new AMap.Map("map-" + id, {
                    resizeEnable: true,
                    // 禁止手动修改地址
                    zoomEnable: temp,
                    dragEnable: temp,
                    zoom: 13,
                });

                var geocoder = {};
                AMap.plugin("AMap.Geocoder", function() {
                    geocoder = new AMap.Geocoder({
                        city: "010", //城市设为北京，默认：“全国”
                        radius: 1000, //范围，默认：500
                    });
                });
                var marker = new AMap.Marker();
                function regeoCode() {
                    if (!temp) {
                        return false;
                    }
                    let lnglat = document.getElementById("lnglat-" + id).value.split(",");
                    mapObj.add(marker);
                    marker.setPosition(lnglat);
                    geocoder.getAddress(lnglat, function(status, result) {
                        // console.log(status)
                        // console.log(result)
                        if (status === "complete" && result.regeocode) {
                        var address = result.regeocode.formattedAddress;
                        document.getElementById("address-" + id).value = address;
                        // 自定义位置后赋值
                        that.$set(that.weizhi, id, address);
                        // console.log(that.weizhi)
                        // console.log(lnglat[1] + "," + lnglat[0])
                        that.data.userAnswer = lnglat[1] + "," + lnglat[0] + ':' + address;
                        
                        that.userAnswerChange()
                        // item1.emptyFrame = option.emptyFrame;
                        } else {
                            console.error("根据经纬度查询地址失败");
                        }
                    });
                }
                mapObj.on("click", function(e) {
                    if (!temp) {
                        return false;
                    }
                    document.getElementById("lnglat-" + id).value = e.lnglat;
                    regeoCode();
                });
                var poiPicker = new PoiPicker({
                    input: "search-" + id,
                    placeSearchOptions: {
                        map: mapObj,
                        pageSize: 6, //关联搜索分页
                    },
                });
                AMap.plugin("AMap.Geolocation", function() {
                    var geolocation = new AMap.Geolocation({
                        enableHighAccuracy: true, //是否使用高精度定位，默认:true
                        timeout: 10000, //超过10秒后停止定位，默认：无穷大
                        maximumAge: 0, //定位结果缓存0毫秒，默认：0
                        showMarker: true, //定位成功后在定位到的位置显示点标记，默认：true
                        showCircle: true, //定位成功后用圆圈表示定位精度范围，默认：true
                        panToLocation: true, //定位成功后将定位到的位置作为地图中心点，默认：true
                        zoomToAccuracy: true, //定位成功后调整地图视野范围使定位位置及精度范围视野s内可见，默认：false
                    });
                    mapObj.addControl(geolocation);
                    geolocation.getCurrentPosition();
                    AMap.event.addListener(geolocation, "complete", onComplete); //返回定位信息
                    AMap.event.addListener(geolocation, "error", onError); //返回定位出错信息
                });
                poiPicker.on("poiPicked", function(poiResult) {
                    poiPicker.hideSearchResults();
                    lat = poiResult.item.location.lat;
                    lng = poiResult.item.location.lng;
                    that.$set(
                        that.weizhi,
                        id,
                        poiResult.item.district + poiResult.item.name
                    );
                    that.mapSearchValue = poiResult.item.district + poiResult.item.name
                    // console.log(that.weizhi)
                    that.data.userAnswer = poiResult.item.location.lat + "," + poiResult.item.location.lng + ':' + poiResult.item.district + poiResult.item.name
                    
                    that.userAnswerChange()
                    mapObj.panTo([lng, lat]);
                });
                function onComplete(data) {
                    var address = "";
                    if (data.addressComponent) {
                        address =
                        data.addressComponent.province +
                        data.addressComponent.district +
                        data.addressComponent.street +
                        data.addressComponent.streetNumber;
                    } else {
                        address = data.address;
                    }
                    that.$set(that.weizhi, id, address);

                    // 自动定位赋值
                    // console.log(data.position.lat + "," + data.position.lng)
                    that.data.userAnswer = data.position.lat + "," + data.position.lng + ':' + address
                    
                    that.userAnswerChange()
                    // item1.emptyFrame = option.emptyFrame;
                }

                function onError(data) {
                //  $('.address .info').text('定位失败！');
                }
            });
        },
        cityHide() {
            this.mapSearchValue = ''
            this.data.userAnswer = ''
            this.mapIsShow = false
            this.userAnswerChange()
        },
        getProvince() {
            let that = this;
            let params = {
                that: this,
                url: `${this.$config.service.queryProvince}`,
                method: "POST",
                cb(res) {
                    // console.log(res)
                    if (res.code == 0) {
                        that.address.province = res.resultBody.datas
                        that.data.userAnswerArr.forEach((info, index) => {
                            that.answerArr[index] = info
                            if (index == 0) {
                                that.seleCity(info, 0)
                            }else if (index == 1) {
                                that.seleCity(info, 1)
                            }else if (index == 2) {
                                that.seleCity(info, 2)
                            } else if (index == 3) {
                                that.answerArrBlur()
                            }
                        })
                    }
                },
            };
            params.isnologin = true
            this.$util.request(params);
        },
        answerArrBlur() {
            // console.log(this.answerArr)
            this.data.userAnswerArr = []
            this.answerArr.forEach((info) => {
                if (info) {
                    this.data.userAnswerArr.push(info)
                }
            })
            this.userAnswerChange()
            // console.log(this.data.userAnswerArr)
        },
        seleCity(e,index) {
            if (index == 0 && this.address.city[e]) {
                //存在省下面的市
                return;
            }
            if (index == 1 && this.address.district[e]) {
                //存在市下面的区
                return;
            }
            if (index == 0) {
                this.answerArr[1] = ''
                this.answerArr[2] = ''
                this.answerArr[3] = ''
            } else if (index == 1) {
                this.answerArr[2] = ''
                this.answerArr[3] = ''
            }
            this.answerArrBlur()
            // this.data.userAnswer = this.answerArr.join()
            let that = this;
            let params = {
                that: this,
                url: `${this.$config.service.queryLinkage}`,
                method: "POST",
                data: {
                    id: e
                },
                cb(res) {
                    // console.log(res)
                    if (res.code == 0) {
                        if (index == 0) {
                            that.address.city = res.resultBody.datas
                        } else if (index == 1) {
                            that.address.district = res.resultBody.datas
                        }
                        
                    }
                },
            };
            params.isnologin = true
            this.$util.request(params);
            this.userAnswerChange()
        },
        beforeFileUpload(file) {
            let size = file.size / 1024 / 1024 < 10; //这里做文件大小限制
            if (!size) {
                this.$message({
                    message: this.$t('UserAnswer.TheFileSizeCannotExceed10MB'),
                    type: "warning",
                });
                return size;
            }
            this.qn.data = file;
        },
        //选择上传文件
        handleRemove(file, fileList, item) {
            let arr = []
            this.data.userAnswerArr = []
            if (fileList.length > 0) {
                fileList.forEach((info) => {
                    this.data.userAnswerArr.push(info.response.message)
                    let y = info.response.message.split('upDataWj/')[1]
                    arr.push({name: y})
                })
            }
            this.data.fileList = arr
            this.userAnswerChange()
        },
        handleexceed(files, fileList) {
            this.$message({
                message: this.$t('UserAnswer.MaximumNumberOfTimes'),
                type: "warning",
            });
        },
        handleSuccess(response, file, fileList, num) {
            let arr = []
            this.data.userAnswerArr = []
            let tempFileList =JSON.parse(JSON.stringify(fileList))
            // console.log(tempFileList)
            tempFileList.forEach((info) => {
                console.log(info)
                if (info.status === 'success' && info.response.code == '0') {
                    this.data.userAnswerArr.push(info.response.message)
                    arr.push({
                        name: info.response.message
                    })
                }
            })
            this.data.fileList = fileList
            this.userAnswerChange()
            // console.log(this.data.fileList)
            // console.log(this.data.userAnswerArr)
        },
        handleerror(err, file, fileList, item) {
            this.$message({
                message: this.$t('UserAnswer.FailedToUploadFile'),
                type: "warning",
            });
        },
        
    }
}
</script>

<style lang="scss" scoped>
.test_question{
    .option-box{
        display: flex;
        flex-direction: column;
        padding-left: 25px;
        .option+.option{
            margin-top: 10px;
        }
    }
}
.list{
    // margin-top: 50px;
    .multiple{
        padding-left: 10px;
        .item-title{
            font-size: 14px;
            margin-bottom: 15px;
        }
    }
    .multiple+.multiple{
        margin-top: 20px;
    }
    .stem{
        padding-left: 10px;
        font-size: 14px;
        line-height: 30px;
    }
}
.required::before{
    content: "*";
    color: #f56c6c;
    margin-right: 4px;
}
.form-item__error{
    color: #f56c6c;
}
/deep/.input__err>.el-textarea__inner{
    border-color: #f56c6c;
}
.input_box{
    padding: 0 10px;
    box-sizing: border-box;
    width:100%;
    display: block;
    flex-wrap: wrap;
}
.input_box-border{
    display: inline-block;
}
.StarsWrap {
  display: flex;
  justify-content: space-between;
  list-style: none;
  margin-top: 10px;
  min-width: 200px;
  max-width: 450px;
  padding-bottom: 5px;
  .StarsWrap-item{
    cursor: pointer;
  }
}
.tips{
    min-width: 200px;
    max-width: 450px;
    display: flex;
    justify-content: space-between;
    font-size: 12px;
    color: #aaaaaa;
}
.baiduMap-btn {    
    width: 50%;
    height: 38px;
    min-width: 200px;
    border: 1px solid #0080ff;
    background: #fff;
    margin-top: 10px;
    cursor: pointer;
}
.map-box{
    margin-top: 20px;
    // width: 700px;
    border: 1px solid #b0b0b0;
    .tip{
        padding: 0 20px;
    }
    .your-location{
        line-height: 30px;
    }
    /deep/.el-input{
        max-width: 300px;
    }
    .search-box{
        display: flex;
        justify-content: space-between;
    }
}
.citySelect {
    margin-top: 20px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    .Select {    
        width: max-content;
        margin-top: 5px;
        width: 100%;
    }
    .setStyle {    
        margin-top: 5px;
        width: 100%;
    }
}
.input_box{
    position: relative;
    
    .form-item__error{
        color: #f56c6c;
        font-size: 12px;
        line-height: 1;
        padding-top: 4px;
    }
}

.questionImage_box {
    width: 46%;
    border: 1px solid #ccc;
    margin: 20px 2% 0 2%;
    padding-bottom: 10px;
    border-radius: 4px;
    box-sizing: border-box; 
}

.questionImage_box .option-img {
  width: 100% ;
  height: 146px ;
  display: block;
}
/deep/.el-checkbox__label,
/deep/.el-radio__label{
    display: flex;
    align-items: center;
    white-space: normal;
    word-break: break-all;
    font-size: inherit;
    text-decoration: inherit;
}
.sort-box{
    width: 100%;
}
.ulChildName {
    .info-body-item+.info-body-item{
        margin-top: 10px
    }
    .option-sort{
        display: inline-block;
        width: 15px;
        height: 15px;
        font-size: 12px;
        line-height: 15px;
        text-align: center;
        border: 1px solid #666;
        border-radius: 50%;
        margin-right: 10px;
    }
    .info-body-item{
        cursor: pointer;
        padding: 0 10px;
        line-height: 30px;
        font-size: 14px;
        width: 100%;
        border: 1px solid #ccc;
        border-radius: 4px;
        display: flex;
        align-items: center;
        box-sizing: border-box;
    }
}
.clear-btn{
    margin-left: 10px;
}
.imgLabel{
    display: flex;
    padding: 5px;
}
.pl10{
    padding-left: 10px;
}
.other-input{
    margin: 8px 0;
}
/deep/.el-upload--text{
    border: 0 !important;
}
</style>